// extracted by mini-css-extract-plugin
export default {"overlay":"bD-z","bodyOpen":"cD-z","content":"dD-z","header":"eD-z","close":"fD-z","closeNoHeading":"gD-z"};